import React from 'react'

// Any Prismic link whose URL ends in "#newsletter" opens the mailing-list signup popup instead of
// navigating. The popup script (emailsys popup.js, loaded in gatsby-ssr.js) binds a document-level
// click handler to `.rm-open-popup`, so editors can put this link on buttons, images or rich text.
export const NEWSLETTER_HASH = '#newsletter'

export const isNewsletterLink = (href) => typeof href === 'string' && href.endsWith(NEWSLETTER_HASH)

// Shared with gatsby-browser.js and gatsby-ssr.js as PrismicProvider's externalLinkComponent
export const ExternalLink = ({ children, activeClassName, ...props }) => {
  if (isNewsletterLink(props.href)) {
    const className = ['rm-open-popup', props.className].filter(Boolean).join(' ')
    return (
      <a data-location='newsletter' {...props} className={className} href={NEWSLETTER_HASH}>
        {children}
      </a>
    )
  }
  return (
    <a data-location='external' {...props} target={props.target || '_blank'} rel={props.rel || 'noopener noreferrer'}>
      {children}
    </a>
  )
}
